import React from "react";
import PageOne from "./Component/PageOne";

const Pemetaan = (props) => {
    const request = props.history.location.state.payload;

    require("./Pemetaan.css");
    return (
        <div>
            {/* Page One */}
            <PageOne idJadwalCbt={request.idJadwalCbt} idKelas={request.idKelas} idKelasParalel={request.idKelasParalel} kodeTahunAjaran={request.kodeTahunAjaran} />
            <div className="fixedButton">
                <button className="buttonPrint" onClick={() => window.print()}>
                    <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} alt="" />
                    Print Report
                </button>
            </div>
        </div>
    );
};

export default Pemetaan;
